import React, { Component } from "react";
import Select from "react-select";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "../panel/panel.jsx";
// import Switch from "@material-ui/core/Switch";
// import Checkbox from "@material-ui/core/Checkbox";
// import FormControlLabel from "@material-ui/core/FormControlLabel";

// ESTILOS CSS PARA LOS INPUTS IMPORTADOS
const colourStyles = {
  input: (styles) => ({
    ...styles,
    color: "#fff",
  }),
  singleValue: (base) => ({
    ...base,
    color: "#fff",
  }),
  control: (styles) => ({
    ...styles,
    backgroundColor: "#505050",
    color: "#fff",
  }),
  placeholder: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  dropdownIndicator: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
    };
  },
  noOptionsMessage: (styles) => {
    return {
      ...styles,
      color: "#ffffff",
      backgroundColor: "#000",
    };
  },
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#1c4d85" : isFocused ? "#1978E2" : "#000",
      color: "#FFF",
      cursor: isDisabled ? "not-allowed" : "default",
      "&:hover": {
        backgroundColor: "#1978E2",
      },
    };
  },
};
// const styles = {
//   root: {
//     color: "#2CBDD7",
//   },
// };

class CreateForm extends Component {
  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/recetas-electronicas/expedidas">
              Recetas electrónicas
            </Link>
          </li>
          <li className="breadcrumb-item active">Expedir</li>
        </ol>
        <h1 className="page-header">Expedir receta electrónica</h1>

        <div className="row">
          <div className="col-md-12">
            <Panel>
              <PanelBody>
                <form
                  style={{ margin: "3%" }}
                  onSubmit={this.props.handleSubmit}
                >
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label htmlFor="establecimiento">
                          Razón social del establecimiento:{" "}
                        </label>
                        <Select
                          id="establecimiento"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={true}
                          onChange={this.props.handleEstablishmentChange}
                          theme="neutral40"
                          value={
                            this.props.state.establecimiento !== null ||
                            this.props.state.establecimiento !== ""
                              ? this.props.state.establecimiento
                              : { label: "Seleccione", key: "0" }
                          }
                          options={this.props.state.cat_establecimientos}
                          getOptionLabel={(establecimiento) =>
                            establecimiento.nombre_establecimiento_texto.toUpperCase()
                          }
                          getOptionValue={(establecimiento) =>
                            establecimiento.establecimiento_id
                          }
                          noOptionsMessage={() =>
                            "No se encontraron establecimientos"
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="producto">
                          Nombre comercial del producto:{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <Select
                          id="producto"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={false}
                          onChange={this.props.handleProductChange}
                          theme="neutral40"
                          value={
                            this.props.state.producto !== null ||
                            this.props.state.producto !== ""
                              ? this.props.state.producto
                              : { label: "Seleccione", key: "0" }
                          }
                          options={this.props.state.cat_productos}
                          getOptionLabel={(producto) =>
                            producto.no_registro
                              ? `${producto.nombre_comercial} (${producto.no_registro})`
                              : producto.nombre_comercial
                          }
                          getOptionValue={(producto) => producto.id}
                          noOptionsMessage={() => "No se encontraron productos"}
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="producto-error"
                        ></div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="presentacion">
                          Presentación: <span className="text-danger"> *</span>
                        </label>
                        <Select
                          id="presentacion"
                          name="presentacion"
                          isMulti={false}
                          isClearable={false}
                          styles={colourStyles}
                          placeholder="Seleccione"
                          onChange={this.props.handlePresentationChange}
                          value={
                            this.props.state.presentacion !== null ||
                            this.props.state.presentacion !== ""
                              ? this.props.state.presentacion
                              : { label: "Seleccione", key: "0" }
                          }
                          theme="neutral40"
                          options={this.props.state.cat_presentacion_producto}
                          getOptionLabel={(presentacion) => {
                            return !presentacion.empaque
                              ? `${presentacion.cantidad} ${presentacion.unidad_medida}`
                              : `${presentacion.empaque.toUpperCase()} (${
                                  presentacion.cantidad
                                }${presentacion.unidad_medida})`;
                          }}
                          getOptionValue={(presentacion) => presentacion.id}
                          noOptionsMessage={() =>
                            "No se encontraron presentaciones"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="presentacion-error"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="cantidad_numero">
                          Cantidad (número):{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          onChange={this.props.handleInputTextChange}
                          value={this.props.state.cantidad_numero}
                          name="cantidad_numero"
                          id="cantidad_numero"
                          className="form-control"
                          placeholder="Ingresar cantidad en número"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="cantidad_numero-error"
                        ></div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="cantidad_texto">
                          Cantidad (texto):{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          onChange={this.props.handleInputTextChange}
                          value={this.props.state.cantidad_texto}
                          name="cantidad_texto"
                          id="cantidad_texto"
                          className="form-control"
                          placeholder="Ingresar cantidad en texto"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="cantidad_texto-error"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="fabricante">
                          Fabricante del producto:{" "}
                        </label>
                        <input
                          type="text"
                          readOnly
                          value={
                            this.props.state.fabricante.razon_social
                              ? this.props.state.fabricante.razon_social.toUpperCase()
                              : ""
                          }
                          name="fabricante"
                          id="fabricante"
                          className="form-control"
                          placeholder="Fabricante del producto"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="fabricante-error"
                        ></div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="paisOrigen">
                          País de origen del producto:{" "}
                        </label>

                        <input
                          type="text"
                          name="paisOrigen"
                          readOnly
                          value={
                            this.props.state.paisOrigen !== ""
                              ? this.props.state.paisOrigen.descripcion.toUpperCase()
                              : ""
                          }
                          className="form-control"
                          id="paisOrigen"
                          placeholder="País de origen del producto"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="paisOrigen-error"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="propietario_nombre">
                          Nombre del propietario del animal o los animales a
                          tratar: <span className="text-danger"> *</span>
                        </label>

                        <input
                          type="text"
                          name="propietario_nombre"
                          onChange={this.props.handleInputTextChange}
                          value={this.props.state.propietario_nombre}
                          className="form-control"
                          id="propietario_nombre"
                          placeholder="Ingrese nombre del propietario"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="propietario_nombre-error"
                        ></div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="propietario_direccion">
                          Dirección del propietario del animal o los animales a
                          tratar: <span className="text-danger"> *</span>
                        </label>

                        <input
                          type="text"
                          name="propietario_direccion"
                          onChange={this.props.handleInputTextChange}
                          value={this.props.state.propietario_direccion}
                          className="form-control"
                          id="propietario_direccion"
                          placeholder="Ingrese dirección del propietario"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="propietario_direccion-error"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="explotacion_pecuaria_razon">
                          Razón social de la explotación pecuaria:
                        </label>

                        <input
                          type="text"
                          name="explotacion_pecuaria_razon"
                          onChange={this.props.handleInputTextChange}
                          value={this.props.state.explotacion_pecuaria_razon}
                          className="form-control"
                          id="explotacion_pecuaria_razon"
                          placeholder="Ingrese razón social de la explotación pecuaria"
                        />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="explotacion_pecuaria_direccion">
                          Dirección exacta de la explotación pecuaria:
                        </label>

                        <input
                          type="text"
                          name="explotacion_pecuaria_direccion"
                          onChange={this.props.handleInputTextChange}
                          value={
                            this.props.state.explotacion_pecuaria_direccion
                          }
                          className="form-control"
                          id="explotacion_pecuaria_direccion"
                          placeholder="Ingrese dirección exacta de la explotación pecuaria"
                        />
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="row">
                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="cantidad_tratar">
                          Cantidad a tratar:{" "}
                          <span className="text-danger">*</span>
                        </label>

                        <input
                          type="text"
                          name="cantidad_tratar"
                          onChange={this.props.handleInputTextChange}
                          value={this.props.state.cantidad_tratar}
                          className="form-control"
                          id="cantidad_tratar"
                          placeholder="Ingrese cantidad a tratar de animales"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="cantidad_tratar-error"
                        ></div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <label htmlFor="producto_especie_dosis">
                          Dosis por especie:{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          id="producto_especie_dosis"
                          name="producto_especie_dosis"
                          isMulti={false}
                          isClearable={false}
                          styles={colourStyles}
                          placeholder="Seleccione"
                          onChange={this.props.handleDoseSpeciesChange}
                          value={
                            this.props.state.producto_especie_dosis !== null ||
                            this.props.state.producto_especie_dosis !== ""
                              ? this.props.state.producto_especie_dosis
                              : { label: "Seleccione", key: "0" }
                          }
                          theme="neutral40"
                          options={this.props.state.cat_producto_especie_dosis}
                          getOptionLabel={(dosis) =>
                            `${
                              dosis.dosis
                            } - ${dosis.especie_texto.toUpperCase()} (${
                              dosis.categoria_texto
                                ? dosis.categoria_texto.toUpperCase()
                                : "SIN CATEGORÍA"
                            })`
                          }
                          getOptionValue={(dosis) => dosis.id}
                          noOptionsMessage={() =>
                            "No se encontraron dosis por especie"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="producto_especie_dosis-error"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-2">
                      <div className="form-group">
                        <label htmlFor="frecuencia">
                          Frecuencia: <span className="text-danger">*</span>
                        </label>

                        <input
                          type="text"
                          name="frecuencia"
                          onChange={this.props.handleInputTextChange}
                          value={this.props.state.frecuencia}
                          className="form-control"
                          id="frecuencia"
                          placeholder="Ingrese frecuencia"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="frecuencia-error"
                        ></div>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="medida_tiempo_frecuencia">
                          Medida del tiempo de la frecuencia:{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          id="medida_tiempo_frecuencia"
                          name="medida_tiempo_frecuencia"
                          isMulti={false}
                          isClearable={false}
                          styles={colourStyles}
                          placeholder="Seleccione"
                          onChange={this.props.handleFrecuencyMeasureTimeChange}
                          value={
                            this.props.state.medida_tiempo_frecuencia !==
                              null ||
                            this.props.state.medida_tiempo_frecuencia !== ""
                              ? this.props.state.medida_tiempo_frecuencia
                              : { label: "Seleccione", key: "0" }
                          }
                          theme="neutral40"
                          options={this.props.state.cat_medida_tiempo}
                          getOptionLabel={(medida) =>
                            medida.descripcion.toUpperCase()
                          }
                          getOptionValue={(medida) => medida.id}
                          noOptionsMessage={() =>
                            "No se encontraron medidas de tiempo"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="medida_tiempo_frecuencia-error"
                        ></div>
                      </div>
                    </div>

                    <div className="col-lg-2">
                      <div className="form-group">
                        <label htmlFor="tratamiento">
                          Tratamiento: <span className="text-danger">*</span>
                        </label>

                        <input
                          type="text"
                          name="tratamiento"
                          onChange={this.props.handleInputTextChange}
                          value={this.props.state.tratamiento}
                          className="form-control"
                          id="tratamiento"
                          placeholder="Ingrese duración"
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="tratamiento-error"
                        ></div>
                      </div>
                    </div>

                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor="medida_tiempo_tratamiento">
                          Medida del tiempo del tratamiento:{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <Select
                          id="medida_tiempo_tratamiento"
                          name="medida_tiempo_tratamiento"
                          isMulti={false}
                          isClearable={false}
                          styles={colourStyles}
                          placeholder="Seleccione"
                          onChange={this.props.handleTreatmentMeasureTimeChange}
                          value={
                            this.props.state.medida_tiempo_tratamiento !==
                              null ||
                            this.props.state.medida_tiempo_tratamiento !== ""
                              ? this.props.state.medida_tiempo_tratamiento
                              : { label: "Seleccione", key: "0" }
                          }
                          theme="neutral40"
                          options={this.props.state.cat_medida_tiempo}
                          getOptionLabel={(medida) =>
                            medida.descripcion.toUpperCase()
                          }
                          getOptionValue={(medida) => medida.id}
                          noOptionsMessage={() =>
                            "No se encontraron medidas de tiempo"
                          }
                        />
                        <div
                          className="invalid-feedback"
                          style={{ display: "none" }}
                          id="medida_tiempo_tratamiento-error"
                        ></div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label htmlFor="producto_descarte">
                          Período de retiro:{" "}
                        </label>
                        <Select
                          id="producto_descarte"
                          styles={colourStyles}
                          placeholder="Seleccione"
                          isClearable={true}
                          onChange={this.props.handleWithdrawalPeriodChange}
                          theme="neutral40"
                          value={
                            this.props.state.producto_descarte !== null ||
                            this.props.state.producto_descarte !== ""
                              ? this.props.state.producto_descarte
                              : { label: "Seleccione", key: "0" }
                          }
                          options={this.props.state.cat_producto_descarte}
                          getOptionLabel={(producto_descarte) =>
                            `${
                              producto_descarte.periodo
                            } ${producto_descarte.medida_tiempo_texto.toUpperCase()} - ${producto_descarte.especie_producto_texto.toUpperCase()}`
                          }
                          getOptionValue={(producto_descarte) =>
                            producto_descarte.id
                          }
                          noOptionsMessage={() =>
                            "No se encontraron periodos de retiro"
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="row">
                    <div className="col-lg-12">
                      <button className="btn btn-success btn-block">
                        Generar
                      </button>
                    </div>
                  </div>
                </form>
              </PanelBody>
            </Panel>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateForm;
